import React, { useEffect, useState } from "react";

import axios from 'axios';
import TwoOptions from "../home/two-options/two-options"
import {emirates_list} from '../../lists/emirates-list';


export default function GetPosition(props) {
  const [emirate, setEmirate] = useState('Dubai');
  const [position, setPosition] = useState ({lat : 25.2048493, lng: 55.2707828})

  useEffect(() => {
      let lat = 25.2048493;
      let lng = 55.2707828;
      navigator.geolocation.getCurrentPosition(function(position) {
        lat = position.coords.latitude;
        lng = position.coords.longitude;
      });
      axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&types=(cities)&key=AIzaSyBKMzsTYEHrnlFQurwvYP2DCV0AJtM4GCY`)
      .then(function (response) {
          let results = response.data.results;
          for (let j = 0; j < results.length; j++){
            let result = results[j];
            if (result.types[0] === "administrative_area_level_1"){
              let area = result.formatted_address.split(' -')[0];
              for (let k = 0; k< emirates_list.length; k++) {
                if (emirate.value === area){
                  setEmirate(area);
                  setPosition({lat: lat, lng: lng});
                }
              };
            }
          }          
      })
      .catch(function (error) {
          console.log(error);
      });
            // eslint-disable-next-line
    }, []);


    return (
      <TwoOptions emirate={emirate} position={position}/>
    );
  
}
